import { useCallback, useEffect, useState } from 'react';

import { ScriptStatus } from '@lyearn/core/hooks/useScript';

import { PlaceSuggestion } from '../types';
import { adaptPlacePredictions } from '../utils';

function useLocationSearch({
  searchText,
  gmapsStatus,
}: {
  searchText: string;
  gmapsStatus: ScriptStatus;
}) {
  const [placeSuggestions, setPlaceSuggestions] = useState<PlaceSuggestion[]>([]);

  const getPlaceSuggestions = useCallback(
    (text: string) => {
      if (gmapsStatus !== ScriptStatus.Success) {
        return null;
      }

      const resolvePredictions = function (
        predictions: google.maps.places.QueryAutocompletePrediction[] | null,
        status: google.maps.places.PlacesServiceStatus,
      ) {
        if (status !== google.maps.places.PlacesServiceStatus.OK || !predictions) {
          return;
        }

        setPlaceSuggestions(
          adaptPlacePredictions(predictions as google.maps.places.AutocompletePrediction[]),
        );
      };

      const autocompleteService = new google.maps.places.AutocompleteService();

      autocompleteService.getQueryPredictions({ input: text }, resolvePredictions);
    },
    [gmapsStatus],
  );

  useEffect(() => {
    if (!searchText) {
      setPlaceSuggestions([]);
    } else {
      getPlaceSuggestions(searchText);
    }
  }, [getPlaceSuggestions, searchText]);

  return {
    data: placeSuggestions,
  };
}

export default useLocationSearch;
